const flashes = [
  {
    time: "今日 09:20",
    tag: "更新",
    tint: "bg-primary-100 text-primary-700",
    title: "倍速新增「片段循环」",
    text: "单句台词反复看，弹幕名场面一次循环到底，二创卡点更顺手。",
  },
  {
    time: "今日 08:05",
    tag: "玩法",
    tint: "bg-accent-100 text-accent-700",
    title: "录屏跟随直播自动分段",
    text: "一场几小时的直播自动切成多段，文件名带时间点，回看找内容超快。",
  },
  {
    time: "昨日 21:40",
    tag: "通道",
    tint: "bg-secondary-100 text-secondary-800",
    title: "解析通道扩容完成",
    text: "晚间高峰出片速度回升，丢链接重试几乎不再排队，吃瓜不断档。",
  },
  {
    time: "昨日 18:12",
    tag: "小贴士",
    tint: "bg-primary-100 text-primary-700",
    title: "去水印建议先选原画档",
    text: "同一段视频，原画保存后再压缩，画质损失更小，细节更经得起回放。",
  },
  {
    time: "昨日 14:30",
    tag: "玩法",
    tint: "bg-accent-100 text-accent-700",
    title: "弹幕聚合双端对齐",
    text: "把两个平台的弹幕拉到同一时间轴，同屏开聊，看热闹氛围翻倍。",
  },
  {
    time: "06-26",
    tag: "合集",
    tint: "bg-secondary-100 text-secondary-800",
    title: "「吃瓜神器玩法合集」上线",
    text: "去水印、解析、倍速、录屏、弹幕、聚合六大玩法拆成一步步小教程，新手跟着走即可。",
  },
];

export default function FlashStream() {
  return (
    <section id="flash" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-radar-line" />
              玩法快讯流
            </span>
            <h2 className="mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              吃瓜神器的玩法进度条
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              功能更新、通道状态、实用小贴士，都按时间线排在这儿，跟一趟就摸清最新玩法。
            </p>
          </div>
          <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            实时滚动中
          </span>
        </div>

        <div className="relative mt-8 pl-5 md:pl-6">
          {/* 时间轴线 */}
          <div className="absolute bottom-2 left-[7px] top-2 w-px bg-secondary-200 md:left-[9px]" />
          <div className="flex flex-col gap-4">
            {flashes.map((f) => (
              <article
                key={f.title}
                className="relative flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 md:gap-5 md:p-5"
              >
                {/* 时间线圆点 */}
                <span className="absolute -left-5 top-6 flex h-[15px] w-[15px] items-center justify-center md:-left-6">
                  <span className="h-[9px] w-[9px] rounded-full bg-accent-500 ring-4 ring-accent-100" />
                </span>
                <span className="mt-0.5 hidden w-24 shrink-0 whitespace-nowrap text-xs text-foreground-500 sm:block">
                  {f.time}
                </span>
                <span
                  className={`mt-0.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${f.tint}`}
                >
                  {f.tag}
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                    {f.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                    {f.text}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}